import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppContext } from '../libs/contextLib';
import AccountLayout from '../components/user/AccountLayout';
import UserForm from '../components/user/UserForm';

export default function AccountProfile() {
  const history = useHistory();
  const { getSession, handleLogout } = useAppContext();
  const [session, setSession] = useState(false);
  const [user, setUser] = useState(false);  

  useEffect(() => {

    async function onLoad() {
        try {                       
            const sess = await getSession()
            setSession(sess)
            setUser(sess.user)

        } catch (e) {
            // onError(e);
        } finally {
            // setIsLoading(false)
        }
    }

    onLoad();
  }, []);

  function handleNav(option) {
    if (option === 'orders') {
      history.push('/account');
    } else if (option === 'profile') {
      // Already here
    } else if (option === 'logout') {
      handleLogout();
    }
  }

  return (    
    <AccountLayout user={user} selected="profile" onNav={handleNav}>
      <UserForm user={user} />
    </AccountLayout>
  );
} 